import { gql } from '@apollo/client'

import { ModalLock } from '../modal-lock'
import {
  LawsuitTwoOffersLock_OfferLockDataFragment,
  LawsuitTwoOffersLock_ViewerFragment,
} from './__generated__/lawsuit-two-offers-lock.graphql'
import { LawsuitTwoOffersLockContainer } from './lawsuit-two-offer-lock-container'

export interface LawsuitTwoOffersLockProps {
  offerLockData: LawsuitTwoOffersLock_OfferLockDataFragment
  viewer: LawsuitTwoOffersLock_ViewerFragment
}

export function LawsuitTwoOffersLock({ offerLockData, viewer }: LawsuitTwoOffersLockProps) {
  return (
    <ModalLock offerLockBody={offerLockData.body}>
      <LawsuitTwoOffersLockContainer viewer={viewer} offerLockData={offerLockData} />
    </ModalLock>
  )
}

LawsuitTwoOffersLock.fragments = {
  offerLockData: gql`
    fragment LawsuitTwoOffersLock_offerLockData on OfferLockData {
      ...LawsuitTwoOffersLockContainer_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${LawsuitTwoOffersLockContainer.fragments.offerLockData}
    ${ModalLock.fragments.offerLockBody}
  `,
  viewer: gql`
    fragment LawsuitTwoOffersLock_viewer on Profile {
      ...LawsuitTwoOffersLockContainer_viewer
    }
    ${LawsuitTwoOffersLockContainer.fragments.viewer}
  `,
}
